<template>
  <div class="dw-footer-main" >
    <div>
      <span><a :href="footerInfo.siteUrl" style="color: #333;"><strong>{{ footerInfo.siteName }}</strong></a>&nbsp;</span>
      <span><a href="/" style="text-decoration: none;color: #333;">{{ footerInfo.siteIcp }}</a>&nbsp;{{ footerInfo.siteMail }}&nbsp;{{ footerInfo.sitePhone }}</span>
    </div>
    <div>
      <span>Powered by <a href="www.99onez.com.net"><strong>99Onez</strong></a> {{ footerInfo.versionNumber }} Vue </span>
    </div>
  </div>
</template>
<script>

import API from '@/api/index.js'

export default {
  name: 'DwFooter',
  data () {
    return {
      footerInfo: {
        siteName: '九九网智调查问卷',
        siteUrl: 'http://www.99onez.com',
        siteIcp: '闽ICP备18001562号-1 | 闽ICP备18001562号-2',
        siteMail: 'yzz@99onez.com',
        sitePhone: '18888888888',
        versionInfo: 'dwsurvey v1',
        versionNumber: 'OSS V1.0',
        versionBuilt: '20240429',
        years: '2017-2024'
      }
    }
  },
  mounted () {
    this.queryDWSurveyFooter()
  },
  methods: {
    queryDWSurveyFooter () {
      this.axios.get(API.surveyFooterInfo, {}).then((response) => {
        const resultData = response.data.data
        console.debug(resultData)
        this.footerInfo = resultData
      })
    }
  }
}
</script>

<style scoped>
.dw-footer-main{
  text-align: center;
  font-size: 12px;
  color: grey;
  line-height: 30px;
  padding-top: 0px;
  padding-bottom: 20px;
}
.dw-footer-main a{
  text-decoration: none;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwFooter.vue